import { DataGrid as MuiDataGrid, DataGridProps } from '@mui/x-data-grid';
import { FC } from 'react';

const DataGrid: FC<DataGridProps> = (props) => (
  <MuiDataGrid
    { ...props }
    sx={
      {
        ...props.sx,
        '& .MuiDataGrid-overlayWrapper': {
          height: '100%',
        },
        '& .MuiDataGrid-overlay': {
          position: 'absolute',
          top: 0,
          left: 0,
          zIndex: 10,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(255, 255, 255, 0.6)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      }

    }
  />
);

export default DataGrid;
